import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SearchIcon from '@material-ui/icons/Search';
import SearchBar from 'material-ui-search-bar';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';
import { sc, moneyFormat } from 'src/utils/Common';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import {
    Card,
    Avatar,
    Input,
    DialogContent,
    Breadcrumbs,
    Link,
    Typography,
    CardContent,
    Container,
    Divider,
    Dialog,
    DialogTitle,
    DialogActions,
    BottomNavigation,
    BottomNavigationAction,
    Grid,
    IconButton,
    Box,
    FormControlLabel,
    Backdrop,
    CircularProgress,
    Button,
    Snackbar,
    ThemeProvider,
    TextField,
    TablePagination, ListItemAvatar, ListItem, ListItemText, List, OutlinedInput, InputAdornment, CardActions,useMediaQuery
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/ExcelExport';
import UrunSearch from 'src/components/Selects/ProductSearch'
import ProductMaterialSearch from 'src/components/Selects/ProductMaterialSearch';
import EditMaterial from 'src/components/SelectMaterial/materialOrderEdit';
import axiosServiceShop from 'src/utils/customAxios';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import Collapse from '@material-ui/core/Collapse';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import trLocale from 'date-fns/locale/tr';
import DateFnsUtils from '@date-io/date-fns';
import AddIcon from '@material-ui/icons/Add';
import { createMuiTheme } from '@material-ui/core/styles';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { useHistory } from 'react-router-dom'; 


const localeMap = {
    tr: trLocale
};

const locale = localStorage.getItem('i18nextLng');

const siyah = '#424242';


const materialTheme = createMuiTheme({
    palette: {
        primary: {
            contrastText: '#FFFFFF',
            dark: siyah,
            main: siyah,
            light: siyah
        }
    }
});

const CssTextField = withStyles({
    root: {
      '& label.Mui-focused': {
        color: '#748E63',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: '#748E63',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#2B2A4C',
        },
        '&:hover fieldset': {
          borderColor: '#99B080',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#748E63',
        },
      },
    },
  })(TextField);


const useStyles = makeStyles(theme => ({
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    cardscontent: {
        minHeight: 300
    },
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    tableRow: {
        '&$hover:hover': {
            backgroundColor: '#E4DCCF'
        }
    },
    tableCell: {
        '$hover:hover &': {
            color: 'black'
        }
    },
    hover: {},
    searchB: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIconB: {
        marginRight: theme.spacing(0),
        color: theme.palette.icon
    },
    searchInputB: {
        flexGrow: 1
    },
    searchButtonB: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
    bottomNav: {
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  bottomNavAction: {
    [theme.breakpoints.down('xs')]: {
      padding: '6px 0px',
      minWidth: 0,
      fontSize: '12px',
    },
  },
  icon: {
    fontSize: '30px',
    [theme.breakpoints.down('xs')]: {
      fontSize: 'small',
    },
  },
}));

const EXTENSIONS = ['xlsx', 'xls', 'csv']

const Return = () => {
    const classes = useStyles();
    const { t } = useTranslation('overview');
    const [SelectedMaterialPopup, setSelectedMaterialPopup] = useState(false);
    const [UrunData, setUrunData] = useState({});
    const [search] = useState('');
    const SessionUser = getUser();
    const [stokOpen, setStokOpen] = React.useState(false);
    const [stokData, setStokData] = React.useState([]);
    const [materialAvailabilityCode, setMaterialAvailabilityCode] = React.useState([]);
    const [ErpStatusOpen, setErpStatusOpen] = React.useState(false);
    const [ErpStatusData, setErpStatusData] = React.useState([]);
    const [statusList] = useState([
        { Id: 1, Name: t('lblNew') },
        { Id: 2, Name: t('lblCancel') },
        { Id: 3, Name: t('lblSAPSent') }
    ]);

    const [SparepartData, setSparePartData] = useState([]);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [ResponseType, setResponseType] = useState('success');

    const [MaterialListData, setMaterialListData] = useState([]); //Product-Material
    const [MaterialListData2, setMaterialListData2] = useState([]); //Only Material

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [loading, setLoading] = useState(false);
    const [ResponseDsc, setResponseDsc] = useState('');
    const [ImagePopup, setImagePopup] = useState(false);
    const [ImageUrl, setImageUrl] = useState('');
    const [searched, setSearched] = useState('');
    const [openEdit, setOpenEdit] = React.useState(false);
    const [materialId, setMaterialId] = React.useState('');
    const [materialCode, setMaterialCode] = React.useState('');
    const [materialDesc, setMaterialDesc] = React.useState('');
    const [sparePartMessage, setSparePartMessage] = React.useState('');
    const [SelectedProductMaterialPopup, setSelectedProductMaterialPopup] = useState(false);
    const [MissingMaterialsPopUp, missingMaterialsPopUp] = React.useState(false);
    const [MissingMaterials, missingMaterials] = React.useState([]);
    const [initialRows, setinitialRows] = useState('');
    const [inputText, setInputText] = useState("");
    const [MaterialData, setMaterialData] = useState({});
    const [openWarning, setopenWarning] = React.useState(false);
    const [Uyari, setUyari] = React.useState('');
    const [MaterialOrderReturnData, setMaterialOrderReturnData] = React.useState(false);
    const [myReturns, setMyReturns] = React.useState(false);
    const [myReturnsDetail, setMyReturnsDetail] = React.useState(false);
    const [myReturnsData, setMyReturnsData] = React.useState([]);
    const [myReturnsDataDetail, setMyReturnsDataDetail] = React.useState([]);
    const isXs = useMediaQuery((theme) => theme.breakpoints.down('xs'));

    const [workorderId, setWorkorderId] = useState('');

    const [StartDateSearch, setStartDateSearch] = useState(
        moment()
            .startOf('day')
            .add(-7, 'days')
            .add(12, 'hours')
            .format('YYYY-MM-DD')
    );
    const [EndDateSearch, setEndDateSearch] = useState(new Date());

    const [QuantityState, setQuantityState] = useState({
        value: 1,
        show: 1,
        backgroundColor: 'white',
    });

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: 'rgb(60, 179, 113)',
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }))(TableRow);

    const setModel = param => {

        setMaterialListData([]);
        const job = {
            ModelCode: param.KUL_MODEL_KODU,
            Model: param.ACIKLAMA,
            HomeWhiz: param.HOMEWHIZ,
            BrandCode: param.MARKA_KODU,
            ProductId: param.MODEL_KODU
        };

        setUrunData(job);

        setLoading(true);
        axios
            .get(`/GetSiriusMaterials/${param.KUL_MODEL_KODU}/1/1/1/1/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/-1`)
            .then(response => {
                setLoading(false);
                if (response.data.length > 0) {
                    response.data.forEach(element => {
                        element.ProductId = param.MODEL_KODU
                        element.ProductName = param.ACIKLAMA
                    });
                    setMaterialListData(response.data);
                    setinitialRows(response.data);
                } else {
                    setMaterialListData([]);
                }
            })
            .catch(error => {
                setLoading(false);
            });
    };

    function setProductMaterial(materialData) {
        if (UrunData.Model && UrunData.ModelCode) {
            if (UrunData.ProductId >= 1000000) {
                setMaterialListData([]);
                materialData.ProductId = UrunData.ProductId
                materialData.ProductName = UrunData.Model
                let result = []
                result.push(materialData)
                setMaterialListData(result);
                setinitialRows(result);
            }
        }
        else {
            setResponseType('error');
            setResponseDsc(t('lblChooseProduct'));
            setOpenSnackbar(true)
        }

    }

    const requestSearch = (searchedVal) => { //Product-Material -Material Search
        const filteredRows = initialRows.filter((item) => sc(
            item.MaterialCode + item.MaterialDesc + item.Ref + item.PriceWithWat.toFixed(2),
            searchedVal
        ));
        setMaterialListData(filteredRows);
        setPage(0);
    };

    const requestSearch2 = (searchedVal) => { //Only Material -Material Search
        const filteredRows = initialRows.filter((item) => sc(
            item.MaterialCode + item.MaterialDesc + item.PriceWithWat.toFixed(2),
            searchedVal
        ));
        setMaterialListData2(filteredRows);
        setPage(0);
    };

    const cancelSearch = () => {
        setSearched('');
        requestSearch(searched);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackbar(false);
    };

    const exportMaterialData = (data) => {
        var json = []
        for (let i = 0; i < data?.length; i++) {
            var temp = {};
            temp.ProductId = data[i].ProductId;
            temp.MaterialCode = data[i].MaterialCode;
            temp.MaterialDesc = data[i].MaterialDesc;
            temp.Ref = data[i].Ref;
            temp.lblQuantity = data[i].Quantity;
            temp.UseQuantity = data[i].UseQuantity;
            temp.DiscountRatio = data[i].DiscountRatio;
            temp.Price = SessionUser.ServiceShopPriceVisible ? data[i].Price : 0;
            temp.PriceWithWat = SessionUser.ServiceShopPriceVisible ? data[i].PriceWithWat : 0;
            temp.lblTotal = SessionUser.ServiceShopPriceVisible ? data[i].Total : 0;
            json.push(temp)
        };

        return json
    };

    const exportExcelExample = [{
        'MaterialCode': '',
        'Quantity': ''
    }];

    const handleQuantityChange = (e, row) => {
        const tmpRow = row;
        const tmpList = [...SparepartData];
        const ifAlreadyHaveItem = tmpList.find(
            x => x.MaterialId === tmpRow.MaterialId
        );

        if (ifAlreadyHaveItem === undefined || ifAlreadyHaveItem === null) {
            tmpRow.Quantity = 1;
            tmpRow.Total = tmpRow.Quantity * tmpRow.PriceWithWat;
            tmpList.push(tmpRow);
        } else {
            var quantity = e.target.value;

            // Quantity rules
            if (quantity > 999) {
                quantity = 999
            }
            else if (quantity < 0) {
                quantity = 0
            }

            const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
            tmpList[index].Quantity = quantity;
            tmpList[index].Total =
                tmpList[index].Quantity * tmpList[index].PriceWithWat;
        }

        setSparePartData(tmpList);
        setQuantityState({ value: quantity, backgroundColor: quantity > 0 ? 'white' : 'red' })
    };

    const deleteFromMaterialTable = row => {
        const tmpListData = [...SparepartData];
        const index = tmpListData.findIndex(x => x.MaterialId === row.MaterialId);
        tmpListData.splice(index, 1);
        setSparePartData(tmpListData);
    };


    const StokControlPopup = (row) => {
        const Request = {
            MaterialCode: [row.MaterialCode],
            ServiceShopCode: SessionUser.ServiceShopCode
          };
      
          const RequestHeaders = {
            headers: { 'Content-Type': 'application/json' }
          };
          axios
            .post('/GetMaterialAvailabilitySirius', Request, RequestHeaders)
            .then(response => {
                const res = response.data.length === 0 ? [] : response.data;
                const stokQuantity = res.map(item => ({
                    ...item,
                    Quantity: parseInt(item.Quantity, 10)
                }));
                setStokData(stokQuantity);
                setMaterialAvailabilityCode(row.MaterialCode);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
        setStokOpen(true);
    }

    const malzemeGosterMaterial = materialCode => {
        const data = {
            MaterialCode: materialCode
        };
        const config = {
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json' }
        };
        axios
            .post('/FileImportExport/SiriusMaterialImage', data, config)
            .then(response => {
                const fileURL = URL.createObjectURL(response.data);

                // newWindow.location = fileURL;
                // newWindow.document.title = materialCode;
                setImageUrl(fileURL);
                setImagePopup(true);
            })
            .catch(error => { });
    };

    function addToMaterialTable(row) {
        // axios
        //   .get(`/GetSparePartMapList` + '/' + row.MaterialId)
        //   .then(response => {
        //     if (response.data.length > 0 && response.data !== "") {
        //         setSparePartMapData(response.data);
        //         var message = t('MaterialHasEquivalent') + ' ' + row.MaterialCode + ' -> ' + response.data[0].NewMaterialCode;
        //         setSparePartMessage(message);
        //     }else{
        //       setSparePartMessage('');
        //     }

        const tmpRow = row;
        const tmpList = [...SparepartData];
        const ifAlreadyHaveItem = tmpList.find(
            x => x.MaterialId === tmpRow.MaterialId
        );
        if (ifAlreadyHaveItem === undefined || ifAlreadyHaveItem === null) {
            tmpRow.Quantity = 1;
            tmpRow.Total = tmpRow.Quantity * tmpRow.PriceWithWat;
            tmpList.push(tmpRow);
        } else {
            const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
            tmpList[index].Quantity += 1;
            tmpList[index].Total =
                tmpList[index].Quantity * tmpList[index].PriceWithWat;
        }

        setSparePartData(tmpList);
        setMaterialId(row.MaterialId);
        setMaterialCode(row.MaterialCode);
        setMaterialDesc(row.MaterialDesc);
        setOpenEdit(true);
        // })
        //   .catch(error => { });
    }

    const setSearchMaterial = param => {
        setMaterialListData2([]);
        const job = {
            MaterialCode: param.MaterialCode, //M.Code
            Material: param.MaterialDesc, //T.FieldText
        };
        setMaterialData(job);

        setLoading(true);

        const Request = {
            SearchParam: inputText.toLocaleLowerCase(localStorage.i18nextLng_normalized),
            ServiceShopId: SessionUser.ServiceShopId
          };
      
          const RequestHeaders = {
            headers: { 'Content-Type': 'application/json' }
          };
          axios
            .post('/GetSiriusMaterialsBySearchKey', Request, RequestHeaders)
            .then(response => {
                setLoading(false);
                if (response.data.length > 0) {
                    response.data.forEach(element => {
                        element.Code = param.MaterialCode
                        element.MaterialName = param.MaterialDesc
                    });
                    setMaterialListData2(response.data);
                    setinitialRows(response.data);
                } else {
                    setMaterialListData([]);
                    const informationAlert = t('lblMissingMaterial');
                    setUyari(informationAlert);
                    setopenWarning(true);
                }
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const handleChange = event => {
        setInputText(event.target.value);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const getExention = (file) => {
        const parts = file.name.split('.')
        const extension = parts[parts.length - 1]
        return EXTENSIONS.includes(extension) // return boolean
    }

    // Import excel function
    function setSearcByExcelhMaterial(excelData) {
        setMaterialListData2([]);

        setLoading(true);

        const request = {
            ExcelDataFormat: excelData,
            ServiceShopId: JSON.stringify(SessionUser.ServiceShopId)
        }
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };

        // A comparer used to determine if two entries are equal.
        const isSameMaterial = (a, b) => a.MaterialCode === b.MaterialCode;

        const onlyInLeft = (left, right, compareFunction) =>
            left.filter(leftValue =>
                !right.some(rightValue =>
                    compareFunction(leftValue, rightValue)));

        axiosServiceShop // service shop url
            .post('/GetSiriusMaterialByExcelData', request, config)
            .then(response => {
                setLoading(false);
                if (response.data.length > 0) {
                    response.data.forEach(element => {
                        element.Total = element.Quantity * element.PriceWithWat;
                    });

                    var missingValues = onlyInLeft(excelData, response.data, isSameMaterial);

                    setMaterialListData2(response.data); // Material Choose popup
                    setSparePartData(response.data); // Table
                    setinitialRows(response.data);

                    if (missingValues.length > 0) {
                        missingMaterials(missingValues);
                        missingMaterialsPopUp(true);
                    }

                    setSelectedMaterialPopup(false); // Close popup
                } else {
                    setMaterialListData([]);
                }
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const importExcel = (e) => {
        const file = e.target.files[0]
        const reader = new FileReader()
        if (file) {
            setLoading(true)
            if (getExention(file)) {
                reader.readAsBinaryString(file)
            }
            reader.onload = (event) => {
                //parse data
                const bstr = event.target.result
                const workBook = XLSX.read(bstr, { type: "binary" })
                //get first sheet
                const workSheetName = workBook.SheetNames[0]
                const workSheet = workBook.Sheets[workSheetName]
                //convert to array
                const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 })
                // Create excel data array
                var excelData = [];

                for (var i = 1; i < fileData.length; i++) {
                    // Check related row data is empty or quantity is valid
                    if ((fileData[i][0] !== undefined && fileData[i][0] !== null && String(fileData[i][0]).trim() !== '') && (fileData[i][1] !== undefined && fileData[i][1] !== null && String(fileData[i][1]).trim() !== '' && !isNaN(+String(fileData[i][1])) && parseInt(String(fileData[i][1])) > 0)) {
                        var quantity = parseInt(String(fileData[i][1])) > 999 ? '999' : String(fileData[i][1])
                        // Add array to related row
                        excelData.push({ MaterialCode: String(fileData[i][0]), Quantity: quantity })
                    }
                }

                if (excelData.length > 0) {
                    // Get related material
                    setSearcByExcelhMaterial(excelData);
                }
            }
        }
    }

    const getSpareUserColor = s => {
        if (s.Quantity !== "0,0") {
            return (
                <Avatar
                    size="small"
                    style={{ color: 'white', backgroundColor: 'green' }}
                >
                    <AccountCircleIcon />
                </Avatar>
            );
        } else {
            return (
                <Avatar
                    size="small"

                    style={{ color: '#424242', backgroundColor: 'red' }}
                >
                    <AccountCircleIcon />
                </Avatar>
            );
        }
    };

    const getStokColor = s => {
        if (s.Quantity > 0) {
            return (
                <Avatar
                    size="small"
                    style={{ color: 'white', backgroundColor: 'green' }}
                >
                    <ShoppingCartIcon />
                </Avatar>
            );
        } else {
            return (
                <Avatar
                    size="small"

                    style={{ color: '#424242', backgroundColor: 'red' }}
                >
                    <ShoppingCartIcon />
                </Avatar>
            );
        }
    };

    const handleCloseEdit = value => {
        setOpenEdit(false);
    }

    function setQuantityNum(value, id) {
        const tmpListData = [...SparepartData];
        const index = tmpListData.findIndex(x => x.MaterialId === id);
        tmpListData[index].Quantity = value;
        tmpListData[index].Total = tmpListData[index].Quantity * tmpListData[index].PriceWithWat;
        setSparePartData(tmpListData);
    }

    const handleChangeStartDateSearch = e => {
        setStartDateSearch(e);
    };
    const handleChangeEndDateSearch = e => {
        setEndDateSearch(e);
    };

    function SaveMaterialOrderReturn() {
        setLoading(true);
        const SetMaterialOrderReturnDetailRequestDto = [];
        for (let i = 0; i < SparepartData.length; i++) {
            const tmpSparePartData = {
                MaterialOrderReturnId: 0,
                MaterialId: SparepartData[i].MaterialId,
                Qty: SparepartData[i].Quantity,
            };
            SetMaterialOrderReturnDetailRequestDto.push(tmpSparePartData);
        }

        const setReturnRequestDto = {
            Id: 0,
            EmployeeId: SessionUser.TechnicianId,
            ServiceShopId: SessionUser.ServiceShopId,
            ErpDoc: '',
            WorkOrderId: workorderId ? workorderId : null,
            MaterialOrderReturnDetails: SetMaterialOrderReturnDetailRequestDto
        };

        const config = {
            headers: { 'Content-Type': 'application/json' }
        };

        axios
            .post('/SetMaterialOrderReturn', setReturnRequestDto, config)
            .then(response => {
                if (response.data.IsSuccess) {
                    setMaterialOrderReturnData({
                        ...MaterialOrderReturnData,
                        orderReturnNumber: response.data.OrderReturnNr,
                        ErpDoc: response.data?.ErpDoc || ''
                    });
                    setResponseType('success');
                    setOpenSnackbar(true); 
                    setSparePartData([]);
                } else {
                    setResponseType('error');
                    setOpenSnackbar(true);
                }
               
                setResponseDsc(response.data.ErrorMessage);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const GetMyReturns = () => {
        const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
        const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
        const Request = {
                StartDate,
                EndDate,
                EmployeeId: SessionUser.TechnicianId,
        };
      
          const RequestHeaders = {
            headers: { 'Content-Type': 'application/json' }
          };

        axios
            .post('/GetMaterialOrderReturn', Request, RequestHeaders)
            .then(response => {
                if (response.data.length > 0) {
                    setMyReturnsData(response.data);
                } else {
                    setMyReturnsData([]);
                    setResponseType('warning');
                    setResponseDsc(t('lblNoResultFound'));
                    setOpenSnackbar(true);
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const GetMyReturnsDetail = (row) => {
        try {
            if (!myReturnsDetail) {
                axios
                    .get('/GetMaterialOrderReturnDetail/' + row.MaterialOrderReturnId)
                    .then(response => {
                        if (response.data.length > 0) {
                            setMyReturnsDataDetail(response.data);
                        } else {
                            setResponseType('warning');
                            setResponseDsc(t('lblNoResultFound'));
                            setOpenSnackbar(true);
                        }
                    })
            }
            setMyReturnsDetail(!myReturnsDetail);
        } catch (error) {
            setResponseType('error');
            setResponseDsc(error.message);
            setOpenSnackbar(true);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (myReturns) {
            GetMyReturns();
        }
    }, [myReturns, StartDateSearch, EndDateSearch]);


const history = useHistory();

const GetServiceShopByTypeId = async () => {
    try {
        const response = await axios.get(`/GetServiceShopByTypeId`);
        if (response.data.length > 0) {
            const foundShop = response.data.find(s => s.Id === SessionUser.ServiceShopId);
            if(foundShop === undefined)
            { 
                alert(t('lblNoAction'));
                history.push('/dashboard');
            }
        }
    } catch (error) {
        console.error("Hata oluştu:", error);
    }
}

const MyReturnsReport = () => {
    history.push('/materialOrder/MyReturnsReport');
}

useEffect(() => {
    GetServiceShopByTypeId();
}, [locale]);


    function Row(props) {
        const { row } = props;

        return (
            <React.Fragment>
                <TableRow  
                    key={row.MaterialReturnId}
                    hover
                    classes={{ hover: classes.hover }}
                    className={classes.tableRow}
                    onClick={() => GetMyReturnsDetail(row)}
                    sx={{ '& > *': { borderBottom: 'unset' } }}>
                    <TableCell align="left">{row.MaterialOrderReturnId}</TableCell>
                    <TableCell align="left">{row.WorkOrderId}</TableCell>
                    <TableCell align="left">{row.ErpDoc}</TableCell>
                    <TableCell align="left">{moment(row.Date).format('DD-MM-YYYY')}</TableCell>
                    <TableCell align="right">
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => GetMyReturnsDetail(row)}
                            style={{
                                fontSize: 'large',
                                color: '#8B7E74'
                            }}
                        >
                            {myReturnsDataDetail
                                .filter((data) => data.MaterialOrderReturnId === row.MaterialOrderReturnId).length > 0 && myReturnsDetail ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={myReturnsDetail} timeout="auto" unmountOnExit>
                            <Box sx={{ margin: 1 }}>
                                {myReturnsDataDetail
                                    .filter((data) => data.MaterialOrderReturnId === row.MaterialOrderReturnId).length > 0 && (
                                        <Table size="small" aria-label="purchases">
                                            <TableHead style={{ backgroundColor: "#FEFCF3" }}>
                                                <TableRow>
                                                    <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                                                    <TableCell align="left">{t('lblQuantity')}</TableCell>
                                                    <TableCell align="left">{t('lblErpDoc')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {myReturnsDataDetail
                                                    .filter((data) => data.MaterialOrderReturnId === row.MaterialOrderReturnId)
                                                    .map((data) => (
                                                        <TableRow key={data.MaterialOrderReturnId}>
                                                            <TableCell align="left">{data.MaterialCode}</TableCell>
                                                            <TableCell align="left">{data.Qty}</TableCell>
                                                            <TableCell align="left">{data.ErpDoc}</TableCell>
                                                        </TableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>
                                    )}
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    const blockInvalidChar = e => ['e', 'E', '+', '-','.'].includes(e.key) && e.preventDefault();

    const AddMaterialFromWorkOrderId = () => {
        axios
            .get('/GetMaterialFromWorkOrderId/' + workorderId)
            .then(response => {
                if (response.data.length > 0) {
                    setSparePartData(response.data);
                } else {
                    setSparePartData([]);
                    setResponseType('warning');
                    setResponseDsc(t('lblNoResultFound'));
                    setOpenSnackbar(true);
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    return (
        <Page>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    message={ResponseDsc}
                    variant={ResponseType}
                />
            </Snackbar>
            <Container maxWidth="xl">
                <Breadcrumbs>
                    <Link color="inherit">Sirius</Link>
                    <Typography color="textPrimary">{t('Material_Order')}</Typography>
                    <Typography color="textPrimary">{t('lblReturn')}</Typography>
                </Breadcrumbs>
                <br />
            <Grid container spacing={1}>
                <Grid item xs={6} sm={2} lg={2}>
                  <CssTextField
                    size="small"
                    id="jobNumber"
                    autoComplete="no"
                    type="number"
                    value={workorderId}
                    onKeyDown={blockInvalidChar}
                    fullWidth
                    label={t('lblWorkOrderId')}
                    variant="outlined"
                    onInput={e => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10);
                        setWorkorderId(e.target.value);
                      }}
                    min={0}
                  />
                </Grid>
                <Grid item xs={6} sm={1} lg={1}>
                  <div style={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        AddMaterialFromWorkOrderId()
                      }}
                    >
                        <AddIcon/>
                    </Button>
                  </div>
                </Grid>
            </Grid>
            <br/>
                <Card>
                    <Grid item xs={12} sm={12} lg={12}>
                        <Card>
                            <BottomNavigation className={classes.bottomNav}>
                                <BottomNavigationAction
                                onClick={MyReturnsReport}
                                showLabel
                                label={t('lblMyReturns')}
                                icon={<AssignmentReturnIcon className={classes.icon} />}
                                className={classes.bottomNavAction}
                                />
                                <ExcelExport JsonData={exportMaterialData(SparepartData)} ButtonType={1} />
                                {!(SessionUser.TenantId === 48 || SessionUser.TenantId === 82 || SessionUser.TenantId === 61) && (
                                <BottomNavigationAction
                                    onClick={() => setSelectedMaterialPopup(true)}
                                    showLabel
                                    label={t('Add Material')}
                                    icon={<AddBoxIcon className={classes.icon} />}
                                    className={classes.bottomNavAction}
                                />
                                )}
                                {!(SessionUser.TenantId === 48 || SessionUser.TenantId === 82 || SessionUser.TenantId === 61) && (
                                <BottomNavigationAction
                                    onClick={() => setSelectedProductMaterialPopup(true)}
                                    showLabel
                                    label={isXs ? t('Add Material Product') : t('Add Material From Product')}
                                    icon={<AddBoxIcon className={classes.icon} />}
                                    className={classes.bottomNavAction}
                                />
                                )}
                            </BottomNavigation>
                            <Divider />
                            <TableContainer style={{ marginTop: '15px' }} component={Paper}>
                                <Table
                                    className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell />
                                            <TableCell />
                                            <TableCell align="left">{t('lblOrderNumber')}</TableCell>
                                            <TableCell align="left">{t('lblSapNr')}</TableCell>
                                            <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                                            <TableCell align="left">{t('lblMaterial')}</TableCell>
                                            <TableCell align="left">{t('lblQuantity')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {SparepartData.map(row => (
                                            <TableRow key={row.MaterialId}>
                                                <TableCell align="center">
                                                    <FormControlLabel
                                                        control={
                                                            <Box p={0.8}>
                                                                <DeleteIcon
                                                                    size="small"
                                                                    color="primary"
                                                                    style={{ color: 'red' }}
                                                                    onClick={() => deleteFromMaterialTable(row)}
                                                                />
                                                            </Box>
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <FormControlLabel
                                                        control={
                                                            <Box p={0.8}>
                                                                <LocalGroceryStoreIcon
                                                                    size="small"
                                                                    color="primary"
                                                                    style={{ color: '#3399FF' }}
                                                                    onClick={() => StokControlPopup(row)}
                                                                />
                                                            </Box>
                                                        }

                                                    />
                                                </TableCell>
                                                <TableCell align="left" component="th" scope="row">
                                                    {row.MaterialOrderId}
                                                </TableCell>
                                                <TableCell align="left" component="th" scope="row">
                                                    {row.SapNr}
                                                </TableCell>
                                                <TableCell align="left" component="th" scope="row">
                                                    {row.MaterialCode}
                                                </TableCell>
                                                <TableCell align="left">{row.MaterialDesc}</TableCell>
                                                <TableCell align="left">
                                                    <Input style={{ width: '45px', textAlign: 'center', backgroundColor: QuantityState.backgroundColor }} type='number' textAlign='center' value={row.Quantity} onChange={(e) => handleQuantityChange(e, row)} />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                    </Grid>
                </Card>
                <CardActions>
                    <Grid xs={11} sm={11} lg={11}></Grid>
                    <Grid xs={1} sm={1} lg={1}>
                            <Button
                                disabled={SparepartData.length > 0 ? false : true}
                                variant="contained"
                                style={{
                                    backgroundColor: SparepartData.length > 0 ? '#862B0D' : '#B7B7B7', 
                                    color: 'white'
                                }}
                                size="small"
                                fullWidth
                                component="span"
                                onClick={SaveMaterialOrderReturn}
                            >
                                {t('lblSend')}
                        </Button>
                    </Grid>
                </CardActions>
                <EditMaterial
                    open={openEdit}
                    value={1}
                    min={1}
                    max={999}
                    onClose={handleCloseEdit}
                    materialId={materialId}
                    materialCode={materialCode}
                    materialDesc={materialDesc}
                    sparePartMessage={sparePartMessage}
                    setQuantityNum={setQuantityNum}
                />
                {/* Add Material From Product BOM */}
                <Dialog
                    open={SelectedProductMaterialPopup}
                    fullWidth
                    maxWidth="lg"
                    onClose={() => setSelectedProductMaterialPopup(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description" >
                    <Grid container >
                        <Grid xs={1} sm={1} lg={1}></Grid>
                        <Grid item xs={10} sm={10} lg={10}>
                            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                                {t('Add Material From Product BOM')}
                            </DialogTitle>
                        </Grid>
                        <Grid xs={1} sm={1} lg={1}>
                            <DialogActions>
                                <IconButton
                                    color="primary"
                                    onClick={() => setSelectedProductMaterialPopup(false)}
                                    aria-label="upload picture"
                                    component="span">
                                    <CloseIcon />
                                </IconButton>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <Container maxWidth="xl" spacing={1}>
                        <Divider />
                        <Card>
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} lg={12}>
                                        <UrunSearch
                                            setModel={setModel}
                                            value={
                                                {
                                                    KUL_MODEL_KODU: UrunData.ModelCode,
                                                    ACIKLAMA: UrunData.Model
                                                } || ''
                                            }
                                            searchParam={search}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} lg={12}>
                                        <ProductMaterialSearch
                                            setProductMaterial={setProductMaterial}
                                            materialIsVisible={(UrunData.Model && UrunData.ModelCode && UrunData.ProductId >= 1000000) ? true : false}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <Divider />
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={4} sm={4} lg={4}>
                                        <SearchBar
                                            inputSizeSmall
                                            value={searched}
                                            onChange={searchVal => requestSearch(searchVal)}
                                            onCancelSearch={() => cancelSearch()}
                                            style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} lg={12}>
                                        <TableContainer component={Paper}>
                                            <Table
                                                stickyHeader
                                                className={classes.table}
                                                size="small"
                                                aria-label="sticky table"
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell />
                                                        <TableCell />
                                                        <TableCell align="left">
                                                            {t('lblMaterialCode')}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {t('lblDescription')}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {t('lblRef')}
                                                        </TableCell>
                                                        <TableCell align="right">{t('lblPrice')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage > 0
                                                        ? MaterialListData.slice(
                                                            page * rowsPerPage,
                                                            page * rowsPerPage + rowsPerPage
                                                        )
                                                        : MaterialListData
                                                    ).map(row => (
                                                        <TableRow key={row.MaterialId} style={SparepartData.includes(row) ? { backgroundColor: '#DEF5E5' } : {}}>
                                                            <TableCell
                                                                align="center"
                                                                className={classes.tableCellMaterial}
                                                            >
                                                                <FormControlLabel
                                                                    control={
                                                                        <ImageSearchIcon
                                                                            onClick={() =>
                                                                                malzemeGosterMaterial(row.MaterialCode)
                                                                            }
                                                                            color="primary"
                                                                        >
                                                                        </ImageSearchIcon>
                                                                    }
                                                                />
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <FormControlLabel
                                                                    control={
                                                                        <AddBoxIcon
                                                                            color="primary"
                                                                            onClick={() => addToMaterialTable(row)}
                                                                        />
                                                                    }
                                                                />
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.MaterialCode}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.MaterialDesc}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.Ref}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {`${SessionUser.ServiceShopPriceVisible ? row.PriceWithWat.toFixed(2) : 0} ${SessionUser.CurrencyUnit
                                                                    }`}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10]}
                                                component="div"
                                                count={MaterialListData.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onChangePage={handleChangePage}
                                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                            />
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Container>
                    <DialogActions />
                </Dialog>
                {/* My Returns */}
                <Dialog
                    open={myReturns}
                    fullWidth
                    maxWidth="lg"
                    onClose={() => setMyReturns(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <Container maxWidth="xl" spacing={1}>
                        <Grid container spacing={1} style={{marginTop:'20px'}}>
                            <Grid item xs={2} sm={2} lg={2}></Grid>
                            <Grid item xs={4} sm={4} lg={4}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={localeMap[locale]}
                                    >
                                        <KeyboardDatePicker
                                            color="primary"
                                            inputVariant="outlined"
                                            id="orderDate"
                                            size="small"
                                            invalidDateMessage={t('hatali_tarih')}
                                            format="dd.MM.yyyy"
                                            fullWidth
                                            label={t('BaslangicTarihi')}
                                            variant="outlined"
                                            value={StartDateSearch}
                                            onChange={e => handleChangeStartDateSearch(e)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>
                            <Grid item xs={4} sm={4} lg={4}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={localeMap[locale]}
                                    >
                                        <KeyboardDatePicker
                                            color="primary"
                                            inputVariant="outlined"
                                            id="orderDate"
                                            size="small"
                                            invalidDateMessage={t('hatali_tarih')}
                                            format="dd.MM.yyyy"
                                            fullWidth
                                            autoComplete="off"
                                            label={t('BitisTarihi')}
                                            variant="outlined"
                                            value={EndDateSearch}
                                            onChange={e => handleChangeEndDateSearch(e)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>
                            <Grid item xs={2} sm={2} lg={2}>
                                <DialogActions>
                                    <IconButton
                                        color="primary"
                                        onClick={() => setMyReturns(false)}
                                        aria-label="upload picture"
                                        component="span">
                                        <CloseIcon />
                                    </IconButton>
                                </DialogActions>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Card>
                            <CardContent>
                                <TableContainer className={classes.container}>
                                    <Table
                                        size="small" aria-label="purchases"
                                    >
                                        <TableHead style={{ backgroundColor: "#F5EBE0" }}>
                                            <TableRow>
                                                <TableCell align="left">{t('Id')}</TableCell>
                                                <TableCell align="left">{t('lblWorkOrderId')}</TableCell>
                                                <TableCell align="left">{t('lblErpDoc')}</TableCell>
                                                <TableCell align="left">{t('lblReturnDate')}</TableCell>
                                                <TableCell align="center"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {myReturnsData.map((row) => (
                                                <Row key={row.MaterialOrderReturnId} row={row} />
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                            <Divider />
                        </Card>
                    </Container>
                    <DialogActions />
                </Dialog>
                {/* Material Add */}
                <Dialog
                    open={SelectedMaterialPopup}
                    fullWidth
                    maxWidth="lg"
                    onClose={() => setSelectedMaterialPopup(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <Grid container >
                        <Grid xs={1} sm={1} lg={1}></Grid>
                        <Grid item xs={10} sm={10} lg={10}>
                            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                                {t('lblMaterialChoose')}
                            </DialogTitle>
                        </Grid>
                        <Grid xs={1} sm={1} lg={1}>
                            <DialogActions>
                                <IconButton
                                    color="primary"
                                    onClick={() => setSelectedMaterialPopup(false)}
                                    aria-label="upload picture"
                                    component="span">
                                    <CloseIcon />
                                </IconButton>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <Container maxWidth="xl" spacing={1}>
                        <Divider />
                        <Card>
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} lg={12}>
                                        <OutlinedInput
                                            id="outlined-adornment"
                                            fullWidth
                                            placeholder={t('Please Enter Material Code Or Name Or SKU (For BOM) Then Click The Button')}
                                            value={inputText}
                                            onChange={handleChange}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search"
                                                        onClick={setSearchMaterial}
                                                    >
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <Divider />
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={4} sm={4} lg={4}>
                                        <SearchBar
                                            value={searched}
                                            onChange={searchVal => requestSearch2(searchVal)}
                                            onCancelSearch={() => cancelSearch()}
                                            style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={4} lg={4}>
                                        <input
                                            id="FileInput"
                                            type='file'
                                            onChange={importExcel}
                                            hidden
                                            accept=".xlsx, .xls, .xml"
                                        >
                                        </input>
                                        <label htmlFor="FileInput">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                fullWidth
                                                component="span"
                                            >
                                                {t('lblChooseFile')}
                                            </Button>
                                        </label>
                                    </Grid>
                                    <Grid item xs={4} sm={4} lg={4}>
                                        <ExcelExport JsonData={exportExcelExample} ButtonType={5} ButtonText={'EXCEL EXAMPLE'} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} lg={12}>
                                        <TableContainer component={Paper}>
                                            <Table
                                                stickyHeader
                                                className={classes.table}
                                                size="small"
                                                aria-label="sticky table"
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell />
                                                        <TableCell />
                                                        <TableCell align="left">
                                                            {t('lblMaterialCode')}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {t('lblDescription')}
                                                        </TableCell>
                                                        <TableCell align="right">{t('lblPrice')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage > 0
                                                        ? MaterialListData2.slice(
                                                            page * rowsPerPage,
                                                            page * rowsPerPage + rowsPerPage
                                                        )
                                                        : MaterialListData2
                                                    ).map(row => (
                                                        <TableRow key={row.MaterialId} style={SparepartData.includes(row) ? { backgroundColor: '#DEF5E5' } : {}}>
                                                            <TableCell
                                                                align="center"
                                                                className={classes.tableCellMaterial}
                                                            >
                                                                <FormControlLabel
                                                                    control={
                                                                        <ImageSearchIcon
                                                                            onClick={() =>
                                                                                malzemeGosterMaterial(row.MaterialCode)
                                                                            }
                                                                            color="primary"
                                                                        >
                                                                        </ImageSearchIcon>
                                                                    }
                                                                />
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <FormControlLabel
                                                                    control={
                                                                        <AddBoxIcon
                                                                            color="primary"
                                                                            onClick={() => addToMaterialTable(row)}
                                                                        />
                                                                    }
                                                                />
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.MaterialCode}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.MaterialDesc}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {`${row.PriceWithWat.toFixed(2)} ${SessionUser.CurrencyUnit
                                                                    }`}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10]}
                                                component="div"
                                                count={MaterialListData2.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onChangePage={handleChangePage}
                                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                            />
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Container>
                    <DialogActions />
                </Dialog>
                {/* Missing Materials */}
                <Dialog
                    open={MissingMaterialsPopUp}
                    fullWidth
                    maxWidth="lg"
                    onClose={() => missingMaterialsPopUp(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <Grid container >
                        <Grid xs={1} sm={1} lg={1}></Grid>
                        <Grid item xs={10} sm={10} lg={10}>
                            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                                {t('Missing Materials')}
                            </DialogTitle>
                        </Grid>
                        <Grid xs={1} sm={1} lg={1}>
                            <DialogActions>
                                <IconButton
                                    color="primary"
                                    onClick={() => missingMaterialsPopUp(false)}
                                    aria-label="upload picture"
                                    component="span">
                                    <CloseIcon />
                                </IconButton>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <Container maxWidth="xl" spacing={1}>
                        <label style={{ color: 'red' }}>The following material codes were not found or defined in your region</label>
                        <Divider />
                        <Paper style={{ maxHeight: 300, overflow: 'auto' }}>
                            <List>
                                {MissingMaterials.map((item) =>
                                    <ListItem>
                                        <ListItemText >{item.MaterialCode}</ListItemText >
                                    </ListItem>
                                )}
                            </List>
                        </Paper>
                    </Container>
                    <DialogActions />
                </Dialog>
                <Dialog
                    open={ImagePopup}
                    fullWidth
                    maxWidth="sm"
                    onClose={() => setImagePopup(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
                </Dialog>
                <Dialog
                    open={stokOpen}
                    onClose={() => setStokOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                >
                    <DialogTitle id="alert-dialog-title">
                        {t('lblMaterialStockSituation')}
                        <Divider />
                    </DialogTitle>
                    <DialogContent>
                        <List component="div" dense>
                            {loading ? (
                                <CircularProgress
                                    status="loading"
                                    style={{ marginLeft: '50%' }}
                                />
                            ) : (
                                stokData.map(s => {
                                    return (
                                        <React.Fragment>
                                            <ListItem
                                                fullWidth
                                                alignItems="flex-start"
                                                key={materialAvailabilityCode}
                                            >
                                                <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                                                <ListItemText
                                                    primary={
                                                        <Typography
                                                            key={materialAvailabilityCode}
                                                            variant="body1"
                                                            className={classes.nestedRight}
                                                        >
                                                            <b>{materialAvailabilityCode}</b>
                                                        </Typography>
                                                    }
                                                    secondary={
                                                        <React.Fragment>
                                                            <Typography
                                                                component="span"
                                                                variant="h6"
                                                                className={classes.inline}
                                                                color="textPrimary"
                                                            >
                                                                {t('StorageDesc')} : {s.StorageLocation}
                                                                <br />
                                                                {t('lblAdet')} : {s.Quantity}
                                                                <br />
                                                                {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : "-"}
                                                                <br />
                                                                {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 && (
                                                                    <div>
                                                                        {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity == 0 ? "-" : moment(s.ETA).format('DD/MM/YYYY')}
                                                                    </div>
                                                                )}
                                                            </Typography>
                                                        </React.Fragment>
                                                    }
                                                />
                                            </ListItem>
                                            <Divider variant="inset" component="li" />
                                        </React.Fragment>
                                    );
                                })
                            )}
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setStokOpen(false)} color="primary">
                            {t('lblOk')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </Page >
    );
}
export default Return;
